import { render, staticRenderFns } from "./SidebarTabExternalAction.vue?vue&type=template&id=5ea2e6c7"
import script from "./SidebarTabExternalAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarTabExternalAction.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports